import { useEffect, useState } from "react";
import PageBar from "../../components/dashboard/page-bar/PageBar";
import ListLanguage from "../../components/languages/list-language/ListLanguage";
import axios from "axios";
import { Loaders } from "../Loaders";

function ListLanguagePage() {
  const [loader, setLoader] = useState(false)
  const [data, setData] = useState();
  const [count, setCount] = useState(10)
  const [page, setPage] = useState(1)

  const [initialVlue, setInitialVlue] = useState({
    search: '',
  })
  const handleChange = (e) => {
    const clone = { ...initialVlue }
    const value = e.target.value
    const name = e.target.name
    clone[name] = value
    setInitialVlue(clone)
  }
  const getLanguageData = async (page) => {
    setLoader(true)
    const clone = { ...initialVlue, page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/language?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(res?.data);
      setLoader(false)
    } catch (error) { setLoader(false) }
  };

  const reset = async (page) => {
    setLoader(true)
    const clone2 = { search: '', page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/language?count=${clone2?.count}&page=${clone2?.page}&search=${clone2?.search}`
      );
      setData(res?.data);
      setInitialVlue({
        search: '',
      })
      setLoader(false)
    } catch (error) { setLoader(false) }
  }

  useEffect(() => {
    getLanguageData(1);
  }, []);
  const onChangeVal = (e) => {
    // console.log(e);
    getLanguageData(e)

  };

  return (
    <>
      {loader && <Loaders />}
      <div className="pageWrapper">
        <PageBar title=" Languages" />
        <h3 className="page-title">
          Manage Languages
        </h3>
        <ListLanguage data={data} getLanguageData={getLanguageData} onChangeVal={onChangeVal} initialVlue={initialVlue} handleChange={handleChange} reset={reset} />
      </div>
    </>
  );
}
export default ListLanguagePage;
